/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalitybigfiveextraversionright4Inputs */



/**
* | output |
* | --- |
* | "Extravert" |
*
* @param {Personalitybigfiveextraversionright4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalitybigfiveextraversionright4 = /** @type {((inputs?: Personalitybigfiveextraversionright4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalitybigfiveextraversionright4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Extravert")
	if (locale === "es") return /** @type {LocalizedString} */ ("Extrovertido")
	return /** @type {LocalizedString} */ ("Экстраверт")
});
export { personalitybigfiveextraversionright4 as "personalityBigFiveExtraversionRight" }